import { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const BobineLoader = ({ processed = 0, total = 0 }) => {
  const { t } = useLanguage();
  const [dots, setDots] = useState('');
  const startTime = useRef(Date.now());
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    startTime.current = Date.now();
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
      setElapsed(Math.round((Date.now() - startTime.current) / 1000));
    }, 600);
    return () => clearInterval(interval);
  }, []);

  const pct = total > 0 ? Math.round((processed / total) * 100) : 0;
  const eta = elapsed > 0 && processed > 0
    ? Math.max(0, Math.round(((total - processed) / (processed / elapsed))))
    : null;

  return (
    <div
      data-testid="bobine-loader"
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', padding: '32px 0',
      }}
    >
      <img
        src="/bobine-face-splash.png"
        alt="Bobine"
        style={{
          width: 120, height: 120,
          objectFit: 'contain',
          animation: 'bobine-spin 6s linear infinite',
          filter: 'drop-shadow(0 0 24px rgba(212,175,55,0.6)) drop-shadow(0 0 50px rgba(212,175,55,0.2))',
        }}
      />

      {/* Barre ivoire discrète */}
      <div style={{
        width: '70%', maxWidth: 300, height: 3, borderRadius: 2,
        backgroundColor: 'rgba(245,245,220,0.12)', marginTop: 24, overflow: 'hidden',
      }}>
        <div data-testid="upload-progress-bar" style={{
          width: `${pct}%`, height: '100%', borderRadius: 2,
          backgroundColor: '#FAF3E0',
          transition: 'width 0.4s ease-out',
        }} />
      </div>

      {/* Compteur ivoire */}
      <span
        data-testid="upload-counter"
        style={{
          fontFamily: "'Georgia', serif",
          fontSize: 15, fontWeight: 300,
          color: '#FAF3E0',
          letterSpacing: 1.5,
          marginTop: 14,
        }}
      >
        {processed} / {total}
      </span>

      {/* Status */}
      <p style={{
        fontFamily: "'Georgia', serif",
        color: '#FAF3E0',
        fontSize: 11, fontStyle: 'italic',
        marginTop: 8, letterSpacing: 0.5,
      }}>
        {processed === 0
          ? `${t('loader_preparing') || 'Pr\u00e9paration'}${dots}`
          : processed < total
            ? `Scellement en cours${dots}`
            : t('loader_finalizing') || 'Finalisation...'}
      </p>

      {/* ETA discret */}
      {eta !== null && eta > 0 && processed < total && (
        <p style={{
          fontFamily: "'Georgia', serif",
          color: '#FAF3E0',
        }}>
          ~{eta}s
        </p>
      )}
    </div>
  );
};

export default BobineLoader;
